export const artists = {
  header: "Our Artists",
  subheader: "Know us better",
  text1: "Discover individual\u00a0styles",
  text2:
    "Discover various individual styles of our artists. See their storyboards, illustrations, vector images, animations, fashion illustrations, digital painting, branding patterns and many other fascinating pieces of graphic art and design.",
};
